const firebaseConfig = {
  apiKey: "AIzaSyBKlni2PCjdeOnXUtgSiirLCBNurQoopuw",
  authDomain: "simpleadmincrud.firebaseapp.com",
  projectId: "simpleadmincrud",
  storageBucket: "simpleadmincrud.appspot.com",
  messagingSenderId: "246793316057",
  appId: "1:246793316057:web:40a2c8b69c87c9cbb800c8",
  measurementId: "G-XFKXDQV76M",
};

export default firebaseConfig